import { makeEntityId } from '@web-platform/shared-universal-types-utils/src/utils';

import type {
  RadarItinerary,
  RadarPlace,
  RadarParentPlace,
} from '@web-platform/shared-universal-types/src/network/endpoints/radar/radarItineraryTypes';
import type { Place } from '@web-platform/shared-universal-types/src/redux/state/places/places';
import type { EntityId } from '@web-platform/shared-universal-types-utils/src/utils';

export const mapRadarPlaces = (itineraries: RadarItinerary[]): Place[] => {
  const placesMap = new Map<EntityId, Place>();

  const mapPlace = (place: RadarPlace | RadarParentPlace): void => {
    const entityId = makeEntityId(place.entityId);
    if (!placesMap.has(entityId)) {
      const countryMap =
        'country' in place
          ? {
              country: place.country,
              countryId: place.countryId,
            }
          : {};
      placesMap.set(entityId, {
        skyNodeCode: place.flightPlaceId,
        entity_id: entityId,
        parentSkyNodeCode: ('parent' in place && place.parent?.flightPlaceId) || undefined,
        parent_entity_id:
          'parent' in place && place.parent?.entityId
            ? makeEntityId(place.parent.entityId)
            : undefined,
        name: place.name,
        type: place.type,
        display_code: place.displayCode,
        ...countryMap,
      });
    }
  };

  itineraries.forEach((itinerary) => {
    itinerary.legs.forEach((leg) => {
      leg.segments.forEach((segment) => {
        mapPlace(segment.origin);
        mapPlace(segment.origin.parent);
        mapPlace(segment.destination);
        mapPlace(segment.destination.parent);
      });
    });
  });

  return Array.from(placesMap.values());
};
